/*
 * Action Types
 */
export enum ServiceDiscoveryTypes {
  LIST_SERVICE_DISCOVERY_REQUEST = '@serviceDiscovery/LIST_SERVICE_DISCOVERY_REQUEST',
  LIST_SERVICE_DISCOVERY_SUCCESS = '@serviceDiscovery/LIST_SERVICE_DISCOVERY_SUCCESS',
  LIST_SERVICE_DISCOVERY_FAILURE = '@serviceDiscovery/LIST_SERVICE_DISCOVERY_FAILURE',

  UPDATE_SERVICE_DISCOVERY_REQUEST = '@serviceDiscovery/UPDATE_SERVICE_DISCOVERY_REQUEST',
  UPDATE_SERVICE_DISCOVERY_SUCCESS = '@serviceDiscovery/UPDATE_SERVICE_DISCOVERY_SUCCESS',
  UPDATE_SERVICE_DISCOVERY_FAILURE = '@serviceDiscovery/UPDATE_SERVICE_DISCOVERY_FAILURE',
}

/*
 * Data types
 */
export interface ServiceDiscoveryInterface {
  type: string;
  title: string;
  subtitle: string;
  key: string;
  value: string | number | boolean;
}

/*
 * State type
 */
export interface ServiceDiscoveryState {
  readonly serviceDiscoveryList: ServiceDiscoveryInterface[];
  readonly serviceDiscoveryData: ServiceDiscoveryInterface;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
